import { render, staticRenderFns } from "./AttendanceStudentDetail.vue?vue&type=template&id=089897c6"
import script from "../../controllers/attendance_student/attendance-student-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_student/attendance-student-detail.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceStudentDetail.vue?vue&type=style&index=0&id=089897c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports